import { render, staticRenderFns } from "./AddHistory.vue?vue&type=template&id=95e31194&scoped=true"
import script from "./AddHistory.vue?vue&type=script&lang=js"
export * from "./AddHistory.vue?vue&type=script&lang=js"
import style0 from "./AddHistory.vue?vue&type=style&index=0&id=95e31194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e31194",
  null
  
)

export default component.exports